// assets
import {
  IconSettings,
  IconMapPin,
  IconFileUpload,
  IconCategory2,
  IconCategoryMinus,
  IconWorld,
  IconContract,
  IconReceiptTax,
  IconMenu2,
  IconCreditCardPay,
  IconList,
  IconFolder,
  IconBuildingBank,
  IconUserSearch,
  IconDeviceDesktopAnalytics,
  IconFileText,
  IconHistory,
  IconTargetArrow,
  IconCashOff,
  IconBox,
  IconEyeSearch,
  IconBook2,
  IconCash,
  IconCreditCard,
  IconMessage2,
  IconMail,
  IconChecklist,
  IconStackFront
} from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

const icons = {
  IconSettings: IconSettings,
  IconMapPin: IconMapPin,
  IconFileUpload: IconFileUpload,
  IconLoanCategory: IconCategory2,
  IconLoanSubcategory: IconCategoryMinus,
  IconLanguage: IconWorld,
  IconAgreementGrievance: IconContract,
  IconTaxConfiguration: IconReceiptTax,
  IconMenuMaster: IconMenu2,
  IconPayoutSetting: IconCreditCardPay,
  IconList: IconList,
  IconFolder: IconFolder,
  IconContract,
  IconMenu2,
  IconLoans: IconBuildingBank,
  IconLoanApplicant: IconUserSearch,
  IconLoanMonitoring: IconDeviceDesktopAnalytics,
  IconFileText: IconFileText,
  IconHistory: IconHistory,
  IconTargetArrow: IconTargetArrow,
  IconDisbursement: IconCashOff,
  IconAppVersionControl: IconBox,
  IconManualKycReview: IconEyeSearch,
  IconLedgerMaster: IconBook2,
  IconLoan: IconCash,
  IconAccount: IconBuildingBank,
  IconPaymentMethods: IconCreditCard,
  IconSmsMaster: IconMessage2,
  IconMailTemplate: IconMail,
  IconMailTemplateList: IconList,
  IconBRERules: IconChecklist,
  IconBRERuleList: IconList,
  IconBRETemplateList: IconStackFront
};

// ==============================|| MENU ITEMS - Admin Panel ||============================== //

const adminPanel: NavItemType = {
  id: 'main',
  type: 'group',
  children: [
    {
      id: 'settings',
      title: 'Settings',
      icon: icons.IconSettings,
      type: 'collapse',
      children: [
        {
          id: 'serviceable-area-pincode',
          title: 'Serviceable Pincode',
          type: 'collapse',
          icon: icons.IconMapPin,
          children: [
            {
              id: 'serviceable-area-pincode',
              title: 'Pincode Management',
              type: 'item',
              url: '/settings/serviceable-area-pincode',
              breadcrumbs: false
            },
            {
              id: 'upload-history',
              title: 'Upload History',
              type: 'item',
              url: '/settings/upload-history',
              breadcrumbs: false
            }
          ]
        },
        {
          id: 'loan-category',
          title: 'Loan Category',
          type: 'item',
          icon: icons.IconLoanCategory,
          url: '/settings/loan-category'
        },
        {
          id: 'loan-subcategory',
          title: 'Loan Subcategory',
          type: 'item',
          icon: icons.IconLoanSubcategory,
          url: '/settings/loan-subcategory'
        },
        {
          id: 'language-master',
          title: 'Language Master',
          type: 'item',
          url: '/settings/language-master',
          icon: icons.IconLanguage
        },
        {
          id: 'account-classification',
          title: 'Account Classification',
          type: 'item',
          url: '/settings/account-classification',
          icon: icons.IconAgreementGrievance
        },
        {
          id: 'bucket-master',
          title: 'Bucket Master',
          type: 'item',
          url: '/settings/bucket-master',
          icon: icons.IconFileUpload
        },
        {
          id: 'agreement-grievance',
          title: 'Agreement & Grievance',
          type: 'item',
          url: '/settings/agreement-grievance',
          icon: icons.IconContract
        },
        {
          id: 'tax-configuration',
          title: 'Tax Configuration',
          type: 'item',
          url: '/settings/tax-configuration',
          icon: icons.IconTaxConfiguration
        },
        {
          id: 'user-management',
          title: 'User Management',
          type: 'collapse',
          icon: icons.IconSettings,
          children: [
            {
              id: 'menu-master',
              title: 'Menu Master',
              type: 'item',
              url: '/settings/menu-master',
              breadcrumbs: false
            },
            {
              id: 'designation-master',
              title: 'Designation Master',
              type: 'item',
              url: '/settings/designation-master',
              breadcrumbs: false
            },
            {
              id: 'users',
              title: 'Users',
              type: 'item',
              url: '/settings/users',
              breadcrumbs: false
            }
          ]
        },
        {
          id: 'payout-setting',
          title: 'Payout Setting',
          type: 'item',
          url: '/settings/payout-setting',
          icon: icons.IconPayoutSetting
        },
        {
          id: 'app-version-control',
          title: 'App Version Control',
          type: 'item',
          url: '/settings/app-version-control',
          icon: icons.IconAppVersionControl
        },
        {
          id: 'payment-settings',
          title: 'Payment Settings',
          type: 'collapse',
          icon: icons.IconPaymentMethods,
          children: [
            {
              id: 'payment-methods',
              title: 'Payment Methods',
              type: 'item',
              url: '/settings/payment-methods',
              breadcrumbs: false
            }
          ]
        },
        {
          id: 'sms-master',
          title: 'SMS Master',
          type: 'item',
          url: '/settings/sms-master',
          icon: icons.IconSmsMaster
        }
      ]
    },
    {
      id: 'loans',
      title: 'Loans',
      type: 'collapse',
      icon: icons.IconLoanApplicant,
      children: [
        {
          id: 'loan-applicants',
          title: 'Applicants',
          type: 'item',
          url: '/loans/applicants',
          icon: icons.IconLoanApplicant
        },
        {
          id: 'loan-monitoring',
          title: 'Loan Monitoring',
          type: 'item',
          url: '/loans/monitoring',
          icon: icons.IconLoanMonitoring
        },
        {
          id: 'disbursement',
          title: 'Disbursement',
          type: 'item',
          url: '/loans/disbursement',
          icon: icons.IconDisbursement
        }
      ]
    },
    {
      id: 'manual-kyc-review',
      title: 'Manual KYC Review',
      type: 'collapse',
      icon: icons.IconManualKycReview,
      children: [
        {
          id: 'kyc-review-queue',
          title: 'Review Queue',
          type: 'item',
          url: '/manual-kyc-review/queue',
          icon: icons.IconLoanApplicant
        }
      ]
    },
    {
      id: 'ledger-master',
      title: 'Ledger Master',
      type: 'collapse',
      icon: icons.IconLedgerMaster,
      children: [
        {
          id: 'loan-ledger',
          title: 'Loan Ledger',
          type: 'item',
          url: '/ledger-master/loan-ledger',
          icon: icons.IconLoan
        },
        {
          id: 'account-ledger',
          title: 'Account Ledger',
          type: 'item',
          url: '/ledger-master/account-ledger',
          icon: icons.IconAccount
        }
      ]
    },
    {
      id: 'mail-template',
      title: 'Mail Templates',
      type: 'collapse',
      icon: icons.IconMailTemplate,
      children: [
        {
          id: 'mail-template-list',
          title: 'All Templates',
          type: 'item',
          url: '/mail-template/list',
          icon: icons.IconMailTemplateList
        }
      ]
    },
    {
      id: 'bre-master',
      title: 'BRE Master',
      type: 'collapse',
      icon: icons.IconBRERules,
      children: [
        {
          id: 'bre-master-rules',
          title: 'Rules',
          type: 'item',
          url: '/bre-master/rules',
          icon: icons.IconBRERuleList
        },
        {
          id: 'bre-master-templates',
          title: 'Templates',
          type: 'item',
          url: '/bre-master/templates',
          icon: icons.IconBRETemplateList
        }
      ]
    }
  ]
};

export default adminPanel;
